export default {
  data() {
    return {
      previewMode: false,
    };
  },
};
